import { DateTime } from "luxon"

export default {
  namespaced: true,
  state: {
    // * INTERNAL WEB PORTAL STATES
    internalAttachmentFilter: {
      idcId: "",
      title: "",
      filename: "",
      uploadedBy: [],
      updatedBy: [],
      description: "",
      tag: [],
      startDate: DateTime.now().startOf("day").toISO(),
      endDate: DateTime.now().toISO(),
      isEnableDate: false,
      pageNumber: 1,
      totalCount: 0,
      perPage: 10,
    },

    internalTicketFilter: {
      type: [],
      status: [
        { id: "OPENED", name: "Opened" },
        { id: "IN_PROGRESS", name: "In Progress" },
      ],
      priority: [],
      ticketId: "",
      idcId: "",
      subjectDetail: "",
      department: [],
      dateTime: {
        start: DateTime.now().startOf("day").toISO(),
        end: DateTime.now().toISO(),
        now: DateTime.now().toISO(),
      },
      createdBy: null,
      isEnableDate: false,
      currentPage: 1,
      totalCount: 0,
      perPage: 10,
    },

    internalSiteAccessFilter: {
      visitors: [],
      siteAccessId: "",
      idcId: "",
      description: "",
      status: [],
      requestDate: {
        start: DateTime.now().startOf("day").toISO(),
        end: DateTime.now().toISO(),
        now: DateTime.now().toISO(),
      },
      isFilterDate: false,
      orderBy: null,
      currentPage: 1,
      totalCount: 1,
      perPage: 10,
    },

    internalSmartHandFilter: {
      jobTitle: "",
      customerName: "",
      idcId: "",
      staffName: "",
      smartHandId: "",
      status: ["Waiting", "In Progress"],
      dateTime: {
        start: DateTime.now().startOf("day").toISO(),
        end: DateTime.now().toISO(),
        now: DateTime.now().toISO(),
      },
      isEnableDate: false,
      currentPage: 1,
      total: 0,
    },

    internalCrossConnectFilter: {
      xConnectId: "",
      idcId: "",
      customerName: "",
      staff: [],
      origin: "",
      destination: "",
      status: ["Waiting", "In Progress"],
      dateTime: {
        start: DateTime.now().startOf("day").toISO(),
        end: DateTime.now().toISO(),
        now: DateTime.now().toISO(),
      },
      isEnableDate: false,
      currentPage: 1,
      total: 0,
    },

    internalParcelTrackingFilter: {
      trackingId: "",
      customerName: "",
      idcId: "",
      status: [
        { id: "WAITING", name: "Waiting" },
        { id: "RECEIVED", name: "Received" },
      ],
      dataType: "",
      dateTime: {
        start: DateTime.now().startOf("day").toISO(),
        end: DateTime.now().toISO(),
        now: DateTime.now().toISO(),
      },
      isEnableDate: false,
      totalCount: 0,
      currentPage: 1,
    },

    internalInventoryFilter: {
      id: "",
      name: "",
      description: "",
      type: [],
      statuses: [],
      location: "",
      pageNumber: 1,
      total: 0,
    },

    internalIdcContractFilter: {
      idcId: "",
      additionalId: "",
      customer: "",
      location: [],
      domainName: "",
      saleContact: null,
      packageAndService: [],
      status: [
        { id: 1, name: "Approved" },
        { id: 3, name: "Pending" },
      ],
      currentPage: 1,
      totalCount: 0,
      perPage: 10,
    },

    internalIdcCustomerFilter: {
      customer: "",
      businessType: [],
      organizationName: "",
      currentPage: 1,
      totalCount: 0,
      perPage: 10,
    },

    internalIdcContactPointFilter: {
      idOrPassportNumber: "",
      role: [],
      contactPoint: "",
      email: "",
      phone: "",
      idcId: "",
      currentPage: 1,
      totalCount: 0,
      perPage: 10,
    },

    internalIpAddressManagerFilter: {
      subnetAddress: [],
      subnetStatus: [],
      subnetTags: [],
      subnetIpAddressOrDescription: null,
      ipVersion: null,
      ipTags: [],
      allocationDateTime: {
        start: DateTime.now().startOf("day").toISO(),
        end: DateTime.now().toISO(),
        now: DateTime.now().toISO(),
      },
      isEnableAllocationDateTime: false,
      idcId: "",
      currentSubnetPage: 1,
      totalSubnetCount: 0,
      currentIpAddressPage: 1,
      totalIpAddressCount: 0,
    },

    internalEscalationTemplate: {
      templateName: "",
      description: "",
      status: [],
      currentPage: 1,
      totalCount: 0,
      perPage: 10,
    },

    internalEscalationHistory: {
      templateName: [],
      level: [],
      ntdcId: "",
      ticketId: "",
      escalateBy: "",
      customerName: "",
      dateTime: {
        start: DateTime.now().startOf("day").toISO(),
        end: DateTime.now().toISO(),
        now: DateTime.now().toISO(),
      },
      isEnableDate: false,
      currentPage: 1,
      totalCount: 0,
      perPage: 10,
    },

    internalEscalationTemplateDetail: {
      currentPage: 1,
      totalCount: 0,
      perPage: 10,
    },

    internalUserManagementFilter: {
      username: "",
      firstname: "",
      lastname: "",
      status: [
        { id: "ACTIVE", name: "Active" },
        { id: "SUSPENDED", name: "Suspended" },
      ],
      departments: [],

      currentPageStaff: 1,
      totalCountStaff: 0,

      currentPageExecutive: 1,
      totalCountExecutive: 0,
    },

    internalWorkloadFilter: {
      user: null,
      action: null,
      resource: null,
      title: "",
      dateTime: {
        start: DateTime.now().startOf("day").toISO(),
        end: DateTime.now().toISO(),
        now: DateTime.now().toISO(),
      },
      isEnableDate: false,
      currentPage: 1,
      totalCount: 1,
      perPage: 10,
    },
    // * EXTERNAL WEB PORTAL STATES
    externalTicketFilter: {
      status: [
        { id: "OPENED", name: "Opened" },
        { id: "IN_PROGRESS", name: "In Progress" },
      ],
      ticketId: "",
      subjectDetail: "",
      dateTime: {
        start: DateTime.now().startOf("day").toISO(),
        end: DateTime.now().toISO(),
        now: DateTime.now().toISO(),
      },
      isEnableDate: false,
      currentPage: 1,
      totalCount: 0,
      perPage: 10,
    },

    externalSiteAccessFilter: {
      visitors: [],
      siteAccessId: "",
      idcId: "",
      description: "",
      status: [],
      requestDate: {
        start: DateTime.now().startOf("day").toISO(),
        end: DateTime.now().toISO(),
        now: DateTime.now().toISO(),
      },
      isFilterDate: false,
      orderBy: null,
      currentPage: 1,
      totalCount: 1,
      perPage: 10,
    },

    externalSmartHandFilter: {
      jobTitle: "",
      description: "",
      smartHandId: "",
      status: ["Waiting", "In Progress"],
      dateTime: {
        start: DateTime.now().startOf("day").toISO(),
        end: DateTime.now().toISO(),
        now: DateTime.now().toISO(),
      },
      isEnableDate: false,
      currentPage: 1,
      total: 0,
    },

    externalCrossConnectFilter: {
      xConnectId: "",
      idcId: "",
      customerName: "",
      origin: "",
      destination: "",
      status: ["Waiting", "In Progress"],
      dateTime: {
        start: DateTime.now().startOf("day").toISO(),
        end: DateTime.now().toISO(),
        now: DateTime.now().toISO(),
      },
      isEnableDate: false,
      currentPage: 1,
      total: 0,
    },

    externalParcelTrackingFilter: {
      trackingId: "",
      customerName: "",
      idcId: "",
      status: [],
      dataType: "",
      dateTime: {
        start: DateTime.now().startOf("day").toISO(),
        end: DateTime.now().toISO(),
        now: DateTime.now().toISO(),
      },
      isEnableDate: false,
      totalCount: 0,
      currentPage: 1,
    },

    // * SMS (M2) Module
    SMSAllEventFilter: {
      from: DateTime.now().minus({ days: 1 }).toISO(),
      to: DateTime.now().toISO(),
      equipments: [],
      resourceTypes: [],
      tags: [],
    },

    // * BMM (M3) Module
    BMMServerManagementFilter: {
      ip: "",
      type: "",
      currentPage: 1,
      totalCount: 0,
    },

    BMMRepositoryFilter: {
      name: "",
      type: "",
      currentPage: 1,
      totalCount: 0,
    },

    BMMBackupFilter: {
      name: "",
      status: "",
      lastResult: "",
      currentPage: 1,
      total: 0,
    },

    BMMCredentialFilter: {
      username: "",
      description: "",
      currentPage: 1,
      totalCount: 0,
    },

    BMMVeeamServerFilter: {
      name: "",
      ip: "",
      currentPage: 1,
      totalCount: 0,
    },

    // * NCM (M4) Module
    NCMConfigHistoryFilter: {
      node: null,
      version: null,
      dateTime: {
        start: DateTime.now().startOf("day").toISO(),
        end: DateTime.now().toISO(),
        now: DateTime.now().toISO(),
      },
      isEnableDate: false,
      currentPage: 1,
      total: 0,
    },

    NCMConfigTemplateFilter: {
      filter: "",
      tag: null,
      currentPage: 1,
      totalCount: 0,
    },

    NCMBackupSettingsFilter: {
      nameOrDescription: "",
      currentPage: 1,
      total: 0,
    },

    // * INTERNAL GLOBAL SETTINGS
    GCFServiceFilter: {
      serviceName: "",
      statuses: ["Active"],
      pageNumber: 1,
      totalCount: 0,
    },
  },
  getters: {
    // * INTERNAL WEB PORTAL GETTERS
    getInternalAttachmentFilter(state) {
      return state.internalAttachmentFilter
    },

    getInternalTicketFilter(state) {
      return state.internalTicketFilter
    },
    getInternalSiteAccessFilter(state) {
      return state.internalSiteAccessFilter
    },
    getInternalSmartHandFilter(state) {
      return state.internalSmartHandFilter
    },
    getInternalCrossConnectFilter(state) {
      return state.internalCrossConnectFilter
    },
    getInternalParcelTrackingFilter(state) {
      return state.internalParcelTrackingFilter
    },
    getInternalInventoryFilter(state) {
      return state.internalInventoryFilter
    },
    getInternalIdcContractFilter(state) {
      return state.internalIdcContractFilter
    },
    getInternalIdcCustomerFilter(state) {
      return state.internalIdcCustomerFilter
    },
    getInternalIdcContactPointFilter(state) {
      return state.internalIdcContactPointFilter
    },
    getInternalIpAddressManagerFilter(state) {
      return state.internalIpAddressManagerFilter
    },
    getInternalEscalationTemplateFilter(state) {
      return state.internalEscalationTemplate
    },
    getInternalEscalationHistoryFilter(state) {
      return state.internalEscalationHistory
    },
    getInternalEscalationTemplateDetailFilter(state) {
      return state.internalEscalationTemplateDetail
    },
    getInternalUserManagementFilter(state) {
      return state.internalUserManagementFilter
    },
    getInternalWorkloadFilter(state) {
      return state.internalWorkloadFilter
    },

    // * EXTERNAL WEB PORTAL GETTERS
    getExternalTicketFilter(state) {
      return state.externalTicketFilter
    },
    getExternalSiteAccessFilter(state) {
      return state.externalSiteAccessFilter
    },
    getExternalSmartHandFilter(state) {
      return state.externalSmartHandFilter
    },
    getExternalCrossConnectFilter(state) {
      return state.externalCrossConnectFilter
    },
    getExternalParcelTrackingFilter(state) {
      return state.externalParcelTrackingFilter
    },

    // * SMS (M2) GETTERS
    getSMSAllEventFilter(state) {
      return state.SMSAllEventFilter
    },

    // * BMM (M3) GETTERS
    getBMMServerManagementFilter(state) {
      return state.BMMServerManagementFilter
    },

    getBMMRepositoryFilter(state) {
      return state.BMMRepositoryFilter
    },

    getBMMBackupFilter(state) {
      return state.BMMBackupFilter
    },

    getBMMCredentialFilter(state) {
      return state.BMMCredentialFilter
    },

    getBMMVeeamServerFilter(state) {
      return state.BMMVeeamServerFilter
    },

    // * NCM (M4) GETTERS
    getNCMConfigHistoryFilter(state) {
      return state.NCMConfigHistoryFilter
    },

    getNCMConfigTemplateFilter(state) {
      return state.NCMConfigTemplateFilter
    },

    getNCMBackupSettingsFilter(state) {
      return state.NCMBackupSettingsFilter
    },

    // * GCF GETTERS
    getGCFServiceFilter(state) {
      return state.GCFServiceFilter
    },
  },
  mutations: {
    // * INTERNAL WEB PORTAL MUTATIONS
    SET_INTERNAL_ATTACHMENT_FILTER(state, value) {
      state.internalAttachmentFilter = value
    },
    SET_INTERNAL_TICKET_FILTER(state, value) {
      state.internalTicketFilter = value
    },
    SET_INTERNAL_SITE_ACCESS_FILTER(state, value) {
      state.internalSiteAccessFilter = value
    },
    SET_INTERNAL_SMART_HAND_FILTER(state, value) {
      state.internalSmartHandFilter = value
    },
    SET_INTERNAL_CROSS_CONNECT_FILTER(state, value) {
      state.internalCrossConnectFilter = value
    },
    SET_INTERNAL_PARCEL_TRACKING_FILTER(state, value) {
      state.internalParcelTrackingFilter = value
    },
    SET_INTERNAL_INVENTORY_FILTER(state, value) {
      state.internalInventoryFilter = value
    },
    SET_INTERNAL_IDC_CONTRACT_FILTER(state, value) {
      state.internalIdcContractFilter = value
    },
    SET_INTERNAL_IDC_CUSTOMER_FILTER(state, value) {
      state.internalIdcCustomerFilter = value
    },
    SET_INTERNAL_IDC_CONTACT_POINT_FILTER(state, value) {
      state.internalIdcContactPointFilter = value
    },
    SET_INTERNAL_IP_ADDRESS_MANAGER_FILTER(state, value) {
      state.internalIpAddressManagerFilter = value
    },
    SET_INTERNAL_ESCALATION_TEMPLATE_FILTER(state, value) {
      state.internalEscalationTemplate = value
    },
    SET_INTERNAL_ESCALATION_HISTORY_FILTER(state, value) {
      state.internalEscalationHistory = value
    },
    SET_INTERNAL_ESCALATION_TEMPLATE_DETAIL_FILTER(state, value) {
      state.internalEscalationTemplateDetail = value
    },
    SET_INTERNAL_USER_MANAGEMENT_FILTER(state, value) {
      state.internalUserManagementFilter = value
    },

    // * EXTERNAL WEB PORTAL MUTATIONS
    SET_EXTERNAL_TICKET_FILTER(state, value) {
      state.externalTicketFilter = value
    },
    SET_EXTERNAL_SITE_ACCESS_FILTER(state, value) {
      state.externalSiteAccessFilter = value
    },
    SET_EXTERNAL_SMART_HAND_FILTER(state, value) {
      state.externalSmartHandFilter = value
    },
    SET_EXTERNAL_CROSS_CONNECT_FILTER(state, value) {
      state.externalCrossConnectFilter = value
    },
    SET_EXTERNAL_PARCEL_TRACKING_FILTER(state, value) {
      state.externalParcelTrackingFilter = value
    },

    // * SMS (M2) MUTATION
    SET_SMS_ALL_EVENT_FILTER(state, value) {
      state.SMSAllEventFilter = value
    },

    // * BMM (M3) MUTATION
    SET_BMM_SERVER_MANAGEMENT_FILTER(state, value) {
      state.BMMServerManagementFilter = value
    },

    SET_BMM_REPOSITORY_FILTER(state, value) {
      state.BMMRepositoryFilter = value
    },

    SET_BMM_BACKUP_FILTER(state, value) {
      state.BMMBackupFilter = value
    },

    SET_BMM_CREDENTIAL_FILTER(state, value) {
      state.BMMCredentialFilter = value
    },

    SET_BMM_VEEAM_SERVER_FILTER(state, value) {
      state.BMMVeeamServerFilter = value
    },

    // * NCM (M4) MUTATION
    SET_NCM_CONFIG_HISTORY_FILTER(state, value) {
      state.NCMConfigHistoryFilter = value
    },

    SET_NCM_CONFIG_TEMPLATE_FILTER(state, value) {
      state.NCMConfigTemplateFilter = value
    },

    SET_NCM_BACKUP_SETTINGS_FILTER(state, value) {
      state.NCMBackupSettingsFilter = value
    },

    // * GCF MUTATION
    SET_GCF_SERVICE_FILTER(state, value) {
      state.GCFServiceFilter = value
    },
  },
  actions: {
    // * INTERNAL ACTIONS
    setInternalAttachmentFilter({ commit }, filter) {
      commit("SET_INTERNAL_ATTACHMENT_FILTER", filter)
    },

    setInternalTicketFilter({ commit }, filter) {
      commit("SET_INTERNAL_TICKET_FILTER", filter)
    },
    setInternalSiteAccessFilter({ commit }, filter) {
      commit("SET_INTERNAL_SITE_ACCESS_FILTER", filter)
    },
    setInternalSmartHandFilter({ commit }, filter) {
      commit("SET_INTERNAL_SMART_HAND_FILTER", filter)
    },
    setInternalCrossConnectFilter({ commit }, filter) {
      commit("SET_INTERNAL_CROSS_CONNECT_FILTER", filter)
    },
    setInternalParcelTrackingFilter({ commit }, filter) {
      commit("SET_INTERNAL_PARCEL_TRACKING_FILTER", filter)
    },
    setInternalInventoryFilter({ commit }, filter) {
      commit("SET_INTERNAL_INVENTORY_FILTER", filter)
    },
    setInternalIdcContractFilter({ commit }, filter) {
      commit("SET_INTERNAL_IDC_CONTRACT_FILTER", filter)
    },
    setInternalIdcCustomerFilter({ commit }, filter) {
      commit("SET_INTERNAL_IDC_CUSTOMER_FILTER", filter)
    },
    setInternalIdcContactPointFilter({ commit }, filter) {
      commit("SET_INTERNAL_IDC_CONTACT_POINT_FILTER", filter)
    },
    setInternalIpAddressManagerFilter({ commit }, filter) {
      commit("SET_INTERNAL_IP_ADDRESS_MANAGER_FILTER", filter)
    },
    setInternalEscalationTemplateFilter({ commit }, filter) {
      commit("SET_INTERNAL_ESCALATION_TEMPLATE_FILTER", filter)
    },
    setInternalEscalationHistoryFilter({ commit }, filter) {
      commit("SET_INTERNAL_ESCALATION_HISTORY_FILTER", filter)
    },
    setInternalEscalationTemplateDetailFilter({ commit }, filter) {
      commit("SET_INTERNAL_ESCALATION_DETAIL_FILTER", filter)
    },
    setInternalUserManagementFilter({ commit }, filter) {
      commit("SET_INTERNAL_USER_MANAGEMENT_FILTER", filter)
    },

    // * EXTERNAL ACTIONS
    setExternalTicketFilter({ commit }, filter) {
      commit("SET_EXTERNAL_TICKET_FILTER", filter)
    },
    setExternalSiteAccessFilter({ commit }, filter) {
      commit("SET_EXTERNAL_SITE_ACCESS_FILTER", filter)
    },
    setExternalSmartHandFilter({ commit }, filter) {
      commit("SET_EXTERNAL_SMART_HAND_FILTER", filter)
    },
    setExternalCrossConnectFilter({ commit }, filter) {
      commit("SET_EXTERNAL_CROSS_CONNECT_FILTER", filter)
    },
    setExternalParcelTrackingFilter({ commit }, filter) {
      commit("SET_EXTERNAL_PARCEL_TRACKING_FILTER", filter)
    },

    // * SMS (M2) ACTIONS
    setSMSAllEventFilter({ commit }, filter) {
      commit("SET_SMS_ALL_EVENT_FILTER", filter)
    },

    // * BMM (M3) ACTIONS
    setBMMServerManagementFilter({ commit }, filter) {
      commit("SET_BMM_SERVER_MANAGEMENT_FILTER", filter)
    },

    setBMMRepositoryFilter({ commit }, filter) {
      commit("SET_BMM_REPOSITORY_FILTER", filter)
    },

    setBMMBackupFilter({ commit }, filter) {
      commit("SET_BMM_BACKUP_FILTER", filter)
    },

    setBMMCredentialFilter({ commit }, filter) {
      commit("SET_BMM_CREDENTIAL_FILTER", filter)
    },

    setBMMVeeamServerFilter({ commit }, filter) {
      commit("SET_BMM_VEEAM_SERVER_FILTER", filter)
    },

    // * NCM (M4) ACTIONS
    setNCMConfigHistoryFilter({ commit }, filter) {
      commit("SET_NCM_CONFIG_HISTORY_FILTER", filter)
    },

    setNCMConfigTemplateFilter({ commit }, filter) {
      commit("SET_NCM_CONFIG_TEMPLATE_FILTER", filter)
    },

    setNCMBackupSettingsFilter({ commit }, filter) {
      commit("SET_NCM_BACKUP_SETTINGS_FILTER", filter)
    },

    // * GCF ACTIONS
    setGCFServiceFilter({ commit }, filter) {
      commit("SET_GCF_SERVICE_FILTER", filter)
    },
  },
}
